import React from "react";

const Label = passedProps => {
  const { children, label, required, helpText, ...props } = passedProps;
  return (
    <label {...props}>
      {children || label}{" "}
      {required && <span className="required-field">*</span>}
      {helpText && <small className="form-text text-muted">{helpText}</small>}
    </label>
  );
};

export default Label;
